<template>
  <card>
    <b-row>
      <b-col cols="10">
        <b-form class="row" v-on:submit.prevent="doFilter">
          <b-col md="12">
            <b-row>
              <b-col md="3">
                <el-input class="input-primary" placeholder="Filter dengan nama" clearable v-model="tableFilter.product_name"/>
              </b-col>
              <b-col md="3">
                <el-select size="large" clearable v-model="tableFilter.category_id" placeholder="Filter dengan category">
                  <el-option v-for="category in categoryList" :value="category.value" :label="category.label" :key="category.id">
                  </el-option>
                </el-select>
              </b-col>
              <b-col md="4">
                <el-date-picker
                  v-model="tableFilter.date"
                  type="daterange"
                  placeholder="Pick a range">
                </el-date-picker>
              </b-col>
              <b-col md="1">
                <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/> Search</button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-select size="large" clearable v-model="tableFilter.color_id" placeholder="Filter dengan warna">
                  <el-option v-for="color in colorList" :value="color.value" :label="color.label" :key="color.id">
                  </el-option>
                </el-select>
              </b-col>
              <b-col md="4">
                <el-select size="large" clearable v-model="tableFilter.size_id" placeholder="Filter dengan ukuran">
                  <el-option v-for="size in sizeList" :value="size.value" :label="size.label" :key="size.id">
                  </el-option>
                </el-select>
              </b-col>
            </b-row>
          </b-col>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12 text-right">
        <b-button size="md" variant="primary" @click="doExportToExcel">
          <font-awesome-icon icon="download"></font-awesome-icon> Export To Excel
        </b-button>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :param-no-uuid="true" :no-actions="true"  :active-url="apiUrl" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['is_active','product_name','category_id', 'color_id', 'size_id', 'start_date', 'end_date']">
      <template slot="content_sub_total" slot-scope="defaultSlotScope">
        {{formatNumber(defaultSlotScope.rowData.sub_total)}}
      </template>
      <template slot="content_sub_profit" slot-scope="defaultSlotScope">
        {{formatNumber(defaultSlotScope.rowData.sub_profit)}}
      </template>
      <!-- <template slot="content_actions" slot-scope="defaultSlotScope">
        <div class="text-center">
          <b-button variant="info" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id" class="mb-0 text-center detail mr-1"><i class="fas fa-info"></i></b-button>
          <b-button v-if="defaultSlotScope.rowData.status === 2" variant="primary" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id + '/edit'" class="mb-0 text-center edit"><i class="fas fa-pencil-alt"></i></b-button>
        </div>
      </template> -->
    </paginated-table>
  </card>
</template>
<script>
  import { Input, Checkbox, DatePicker, Select, Option } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTableWithResource'
  import CreateNewData from '@/components/Buttons/CreateNewData'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      CreateNewData,
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
      elCheckbox: Checkbox
    },
    data () {
      return {
        dataKey: 'product-favorite',
        apiUrl: window.AppConfig.apiUrl + 'product-favorite',
        columns: [
          {
            prop: 'product_name',
            label: 'Nama Item'
          },
          {
            prop: 'category_name',
            label: 'Kategori'
          },
          {
            prop: 'color',
            label: 'Warna'
          },
          {
            prop: 'size',
            label: 'Ukuran'
          },
          {
            prop: 'totalSale',
            label: 'Total Penjualan'
          },
          {
            prop: 'sub_total',
            label: 'Sub Total',
            class: 'text-right',
            sortable: true
          },
          {
            prop: 'sub_profit',
            label: 'Sub Profit',
            sortable: true
          },
          {
            prop: 'created_at',
            label: 'Tgl Dibuat',
            sortable: true
          }
        ],
        categoryList: [],
        colorList: [],
        sizeList: [],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          product_name: this.$route.query.product_name,
          category_id: this.$route.query.category_id,
          color_id: this.$route.query.color_id,
          size_id: this.$route.query.size_id,
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          date: null
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
        this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      doExportToExcel () {
        let url = window.AppConfig.webUrl + 'export-product-favorit-excel?token=' + this.$store.getters['account/tokens'].access_token
        if (this.tableFilter.size_id !== null && this.tableFilter.size_id !== undefined) {
          url += '&size_id=' + this.tableFilter.size_id
        }
        if (this.tableFilter.product_name !== null && this.tableFilter.product_name !== undefined) {
          url += '&product_name=' + this.tableFilter.product_name
        }
        if (this.tableFilter.category_id !== null && this.tableFilter.category_id !== undefined) {
          url += '&category_id=' + this.tableFilter.category_id
        }
        if (this.tableFilter.color_id !== null && this.tableFilter.color_id !== undefined) {
          url += '&color_id=' + this.tableFilter.color_id
        }
        if (this.tableFilter.date !== null && this.tableFilter.date.length > 0) {
          url += '&start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
        }
        window.open(url)
      },
      getCategory () {
        this.$http.get(window.AppConfig.apiUrl + 'category?limit=100').then(resp => {
          resp.data.data.forEach(data => {
            this.categoryList.push({
              value: data.id,
              label: data.name
            })
          })
        })
      },
      getColor () {
        this.$http.get(window.AppConfig.apiUrl + 'color?limit=100').then(resp => {
          resp.data.data.forEach(data => {
            this.colorList.push({
              value: data.id,
              label: data.name
            })
          })
        })
      },
      getSize () {
        this.$http.get(window.AppConfig.apiUrl + 'size?limit=100').then(resp => {
          resp.data.data.forEach(data => {
            this.sizeList.push({
              value: data.id,
              label: data.name
            })
          })
        })
      },
      getColorStatus (status) {
        if (status === 'Canceled') {
          return 'dark'
        } else if (status === 'Paid') {
          return 'success'
        } else if (status === 'Invoice') {
          return 'primary'
        } else if (status === 'Working') {
          return 'warning'
        } else if (status === 'New') {
          return 'info'
        } else {
          return 'danger'
        }
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Pending'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Lunas'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Tahan'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'Batal'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getDate (value) {
        return this.$moment(value).format('DD-MM-YYYY')
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      }
    },
    mounted () {
      // this.initData().requestCategory()
      this.getCategory()
      this.getColor()
      this.getSize()
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/ProductFavorites/Index.vue